import isEmpty from 'lodash/isEmpty'
import PortfolioProject from '@/models-ts/user/PortfolioProject'

const comparedFields = ['projectName', 'projectInfo', 'files']

// @ts-ignore
export default (exp: PortfolioProject) => comparedFields.some((field) => !isEmpty(exp[field]))
